export default __webpack_public_path__ + "static/media/hotel-building.d7e336ba.svg";